import { render } from "./px-slider-card.vue?vue&type=template&id=eaae57c8&scoped=true&ts=true"
import script from "./px-slider-card.vue?vue&type=script&lang=ts"
export * from "./px-slider-card.vue?vue&type=script&lang=ts"

import "./px-slider-card.vue?vue&type=style&index=0&id=eaae57c8&lang=scss&scoped=true"
import "./px-slider-card.vue?vue&type=style&index=1&id=eaae57c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaae57c8"]])

export default __exports__